import { desactivarPreguntaCliente } from "../../function/desactivarPreguntaCliente";

// Encargada de esconder el ringpool según el horario y otros parametros (de momento)
export function HandleRingpool() {
    const observer = new MutationObserver(() => {

        const dateTimeContainer = document.getElementsByClassName("date_text")[0];

        const hourActuali = new Date();
        const hourStart = 9;
        const hourEnd = 21;
        const Saturday = hourActuali.getDay() == 6 && hourActuali.getHours() >= hourStart && hourActuali.getHours() <= 13;

        //Impementacion para millon-vida luego se eliminara
        const urlMillon = new URL(window.location);

        // if (dateTimeContainer && Saturday && (window.site == "coche" || window.site == "moto" || window.site == "hogar")) {
        //     dateTimeContainer.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
        // } else 

        if (Saturday && (window.site.toLowerCase() == "moto" || window.site.toLowerCase() == "coche" || window.site.toLowerCase() == "hogar")) {
            console.log("sabado laboral");
        } else if (hourActuali.getHours() < hourStart || hourActuali.getHours() >= hourEnd || hourActuali.getDay() == 0 || hourActuali.getDay() == 6) {
            deleteRingpool();
        }

        //Implementacion para millon-vida (luego se eliminara)
        if (urlMillon.pathname == '/ahorro-inversion/ahorro/millon-vida-saldo-limitado/') {
            deleteRingpoolAndHorary();
            desactivarPreguntaCliente();
        }

        setTimeout(() => {
            observer.disconnect();
        }, 3000);
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

// Elimina el contenedor del ringpool que esta en el formulario.
export function deleteRingpool() {
    const ringpoolObserver = new MutationObserver(() => {

        const containersRingpool = document.querySelectorAll("#business_hours_container .botonera");
        if (containersRingpool.length) {

            for (let i = 0; i < containersRingpool.length; i++) {
                containersRingpool[i].style.display = "none";
            }

            setTimeout(() => {
                ringpoolObserver.disconnect();
            }, 3000);
        }
    });

    ringpoolObserver.observe(document.body, { childList: true, subtree: true });
}

// Elimina el contenedor del horario que está debajo del ringpool.
export function deleteHorario() {
    const horariolObserver = new MutationObserver(() => {

        const containersHorarioContacto = document.querySelectorAll("#business_hours_container .date_conteiner");

        if (containersHorarioContacto) {

            for (let i = 0; i < containersHorarioContacto.length; i++) {
                containersHorarioContacto[i].style.display = "none";
            }

            setTimeout(() => {
                horariolObserver.disconnect();
            }, 3000);
        }
    });

    horariolObserver.observe(document.body, { childList: true, subtree: true });
}

export function deleteRingpoolAndHorary() {
    const containerRingpoolHorary = new MutationObserver(() => {

        const containersHorarioContacto = document.getElementById("business_hours_container");

        if (containersHorarioContacto) {

            containersHorarioContacto.style.display = "none";

            setTimeout(() => {
                containerRingpoolHorary.disconnect();
            }, 3000);
        }
    });

    containerRingpoolHorary.observe(document.body, { childList: true, subtree: true });
}



// WEBPACK FOOTER //
// ./js/utils/modal/handleRingpool.js